import React, { FC, useState } from 'react';
import styled from 'styled-components/native';
import Colors from 'theme/colors';
import Fonts from 'theme/fonts';
import { HOW_TO_STEPS } from 'config/toeicMeta';

const STORAGE_KEY = 'toeic_howto_dismissed_v1';

const Card = styled.View`
  background-color: ${Colors.SURFACE};
  border-width: 1px;
  border-color: ${Colors.CARD_BORDER};
  border-radius: 12px;
  padding: 16px;
  margin: 4px 8px 16px;
`;

const Title = styled(Fonts.Bold)`
  font-size: 16px;
  color: ${Colors.MAIN_COLOR};
  margin-bottom: 8px;
`;

const Step = styled(Fonts.Normal)`
  font-size: 14px;
  color: ${Colors.TEXT};
  line-height: 22px;
  margin-bottom: 4px;
`;

const Dismiss = styled.TouchableOpacity`
  align-self: flex-start;
  margin-top: 10px;
  padding-vertical: 4px;
`;

const DismissText = styled(Fonts.Normal)`
  font-size: 13px;
  color: ${Colors.MUTED_TEXT};
  text-decoration: underline;
`;

const readDismissed = (): boolean => {
  try {
    const g: any = typeof global !== 'undefined' ? global : {};
    const ls = (g.window && g.window.localStorage) || g.localStorage;
    return ls && ls.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const writeDismissed = () => {
  try {
    const g: any = typeof global !== 'undefined' ? global : {};
    const ls = (g.window && g.window.localStorage) || g.localStorage;
    if (ls) ls.setItem(STORAGE_KEY, '1');
  } catch {
    /* ignore */
  }
};

const HowToPractice: FC = () => {
  const [hidden, setHidden] = useState(readDismissed);

  if (hidden) return null;

  const dismiss = () => {
    writeDismissed();
    setHidden(true);
  };

  return (
    <Card>
      <Title>Cách ôn nhanh (lần đầu dùng)</Title>
      {HOW_TO_STEPS.map((step, i) => (
        <Step key={step}>{`${i + 1}. ${step}`}</Step>
      ))}
      <Dismiss onPress={dismiss}>
        <DismissText>Đã hiểu — ẩn hướng dẫn</DismissText>
      </Dismiss>
    </Card>
  );
};

export default HowToPractice;
